// extracted by mini-css-extract-plugin
export var fileExt = "_w6-8";
export var fileIcon = "_w6-6";
export var fileLink = "_w6-5";
export var fileName = "_w6-7";
export var image = "_w6-1";
export var imageError = "_w6-3";
export var imageErrorIcon = "_w6-4";
export var imageLink = "_w6-0";
export var imageLoaded = "_w6-2";